import React from "react";
import "./Hero2.css";

export default function Hero() {
  return (
    <section className="hero2" id="hero2">
      {/* ✅ Overlay for better contrast */}
      <div className="hero2-overlay2"></div>
      <div className="hero2-content2">
        <h1>Visualize your Favourite Shades</h1>
        <button className="cta2-btn2">BUY YOUR FAVOURITE PAINTS NOW!</button>
      </div>
    </section>
  );
}
